import Dashboard from "views/Dashboard.js";
import Profile from "views/Profile";
import { OBJ } from "constants";
import { APP_KEYS } from "constants";

export const routeObjects = [
    { obj: OBJ.DASHBOARD, icon: 'icon-chart-pie-36', component: Dashboard, crm:true, marketing:true, settings: true,
        [APP_KEYS.SPEICHERFUCHS]:true, [APP_KEYS.SAVVYSPEAK]:true  },
    
    { obj: OBJ.CUSTOMERS, icon: 'icon-single-02', crm: true, [APP_KEYS.SPEICHERFUCHS]:true },
    { obj: OBJ.EMAILS, icon: 'icon-email-85', crm: true },
    { obj: OBJ.TODOS, icon: 'icon-check-2', crm: true  },
    { obj: OBJ.NOTES, icon: 'icon-notes', crm: true  },
    { obj: OBJ.INTERACTIONS, icon: 'icon-mobile', crm: true  },
    
    { obj: OBJ.CHATS, icon: 'icon-vector', marketing: true },
    { obj: OBJ.CHAT_SESSIONS, icon: 'icon-chat-33', marketing: true },
    { obj: OBJ.CHAT_DESIGNS, icon: 'icon-palette', marketing: true },
    { obj: OBJ.EVENTS, icon: 'icon-calendar-60', marketing: true },
    { obj: OBJ.MESSAGE_TEMPLATES, icon: 'icon-paper', marketing: true },
    { obj: OBJ.COMMUNICATION_PLANS, icon: 'icon-vector', marketing: true },
    { obj: OBJ.EVENT_PARTICIPANTS, icon: 'icon-single-02', marketing: true },
    { obj: OBJ.SOCIAL_MEDIA_ACCOUNTS, icon: 'icon-single-02', marketing: true },
    { obj: OBJ.LINKEDIN_ACTIONS, icon: 'icon-chat-33', marketing: true },
    

    { obj: OBJ.PRODUCTS, icon: 'icon-bullet-list-67', oms: true  },
    { obj: OBJ.ORDERS, icon: 'icon-cart', oms: true  },
    { obj: OBJ.CONTRACTS, icon: 'icon-single-copy-04', oms: true  },

    { obj: OBJ.DOCUMENTS, icon: 'icon-single-copy-04', [APP_KEYS.SPEICHERFUCHS]:true },
    { obj: OBJ.BANK_ACCOUNTS, icon: 'icon-credit-card', [APP_KEYS.SPEICHERFUCHS]:true },
    { obj: OBJ.CONTACT_RELATIONSHIPS, icon: 'icon-link-72', [APP_KEYS.SPEICHERFUCHS]:true },

    { obj: OBJ.KNOWLEDGE, icon: 'icon-book-bookmark', training: true },
    { obj: OBJ.UPLOADS, icon: 'icon-cloud-upload-94', training: true },
    { obj: OBJ.PROMPTS, icon: 'icon-chat-33', training: true },
    { obj: OBJ.TERM_CORRECTIONS, icon: 'icon-pencil', training: true },

    { obj: OBJ.TENANTS, icon: 'icon-settings', settings: true },    

    { obj: OBJ.AVATARS, icon: 'icon-single-02', settings: true },
    { obj: OBJ.SIGNATURES, icon: 'icon-pencil', settings: true },
    { obj: OBJ.ACCOUNT_SETTINGS, icon: 'icon-email-85', settings: true },
    { obj: OBJ.INTEGRATIONS, icon: 'icon-puzzle-10', settings: true },
    { obj: OBJ.USERS, icon: 'icon-settings', settings: true },
    { obj: OBJ.ROLES, icon: 'icon-settings', settings: true },
    { obj: OBJ.METADATA, icon: 'icon-badge', settings: true },
    { obj: OBJ.IMPORT_DATA, icon: 'icon-cloud-upload-94', settings: true },
    { obj: OBJ.PROFILE, icon: 'icon-single-02', component: Profile, crm:true, marketing:true, settings: true, 
        training: true, oms: true, [APP_KEYS.SPEICHERFUCHS]:true, [APP_KEYS.SAVVYSPEAK]:true},        
]; 